// A two-column tooltip: what the row IS on the left, WHERE it is on the
// right. A schedule row's name and dates tell you nothing about which
// part of the floor it covers, and the areas page is a different page -
// so the drawing comes to the row instead.
import React from "react";
import AreaShapePreview from "components/Coordination/AreaShapePreview";

export default function AreaTooltip({ children, areas, width = 250 }) {
  const list = Array.isArray(areas) ? areas.filter(Boolean) : [];
  return (
    <div style={{ display: "flex", gap: 12, alignItems: "flex-start", maxWidth: 560 }}>
      <div style={{ flex: "1 1 auto", minWidth: 180, fontSize: 12, lineHeight: 1.5 }}>
        {children}
      </div>
      {list.length > 0 && (
        <div style={{ flex: "0 0 auto" }}>
          {list.slice(0, 2).map((a) => (
            // Zoomed: the zone fills the frame rather than sitting on the
            // sheet as a speck.
            <div key={a._id} style={{ marginBottom: list.length > 1 ? 8 : 0 }}>
              <AreaShapePreview area={a} zoom width={width} height={Math.round(width * 0.72)} />
            </div>
          ))}
          {/* How the zone sits across the architectural areas (the key
              plan's A-F) and which older zone it replaced - the overview
              of the area, not just its shape (owner, 2026-09-17). */}
          {list.slice(0, 2).some((a) => (a.archOverlap || []).length || (a.replaces || []).length) && (
            <div style={{ fontSize: 11, lineHeight: 1.45, marginTop: 6, maxWidth: width }}>
              {list.slice(0, 2).map((a) => (
                <div key={`o-${a._id}`} style={{ marginBottom: 4 }}>
                  {(a.archOverlap || []).length > 0 && (
                    <div>
                      <b>{a.sheetLevel ? `${a.sheetLevel} · ` : ""}Architectural:</b>{" "}
                      {a.archOverlap.map((o) => `Area ${o.name} ${Math.round((o.zoneShare || 0) * 100)}%`).join(" · ")}
                      {a.archOverlap.length > 1 && <span style={{ opacity: 0.75 }}> (spans {a.archOverlap.length} areas)</span>}
                    </div>
                  )}
                  {a.grid && a.grid.label && <div style={{ opacity: 0.75 }}>Grid {a.grid.label}</div>}
                  {(a.replaces || []).length > 0 && (
                    <div style={{ opacity: 0.75 }}>Replaces: {a.replaces.map((r) => `${r.name} (${Math.round((r.overlap || 0) * 100)}%)`).join("; ")}</div>
                  )}
                </div>
              ))}
            </div>
          )}
          {list.length > 2 && (
            <div style={{ fontSize: 11, opacity: 0.75 }}>+{list.length - 2} more area(s)</div>
          )}
        </div>
      )}
    </div>
  );
}
